import { Container } from '@spark-web/container';
import { Stack } from '@spark-web/stack';
import { Text } from '@spark-web/text';

import ErrorImage from '../public/error.svg';
import BrighteLogo from '../public/logo.svg';

export const Maintenance = ({ endDate }: { endDate?: string }) => {
  const formattedEndDate = endDate ? new Date(endDate) : null;

  return (
    <Container>
      <Stack gap="xxlarge">
        <Stack gap="xxlarge" padding="xlarge">
          <Stack align="left">
            <img src={BrighteLogo} alt="Brighte logo" height={30} />
          </Stack>
        </Stack>
        <Stack gap="xxlarge" padding="xlarge" marginBottom="xlarge">
          <Stack align="left" gap="xlarge">
            <img src={ErrorImage} alt="error" />
          </Stack>

          <Text>
            We’ll be back in a bit. We are currently undergoing maintenance to ensure you get the best application
            experience.
          </Text>

          <Stack gap="xxlarge">
            {formattedEndDate && (
              <Text>
                The maintenance is expected to run until{' '}
                {formattedEndDate.toLocaleString('en-AU', {
                  dateStyle: 'long',
                  timeStyle: 'short',
                })}
                .
              </Text>
            )}
            <Text>Thank you for your patience and understanding.</Text>
            <Text>Brighte Team</Text>
          </Stack>
        </Stack>
      </Stack>
    </Container>
  );
};
